// @flow
import classnames from 'classnames';

import css from '@styles/productDetail/shippingInfo';

type TProps = {
  deliveryDate: ?string,
  borders?: boolean
};

const fedexLogo = '/images/fedex.svg';

export default function ({ deliveryDate, borders = true }: TProps) {
  return (
    <div className={classnames(css.container, { borders })}>
      <img className={css.fedex} src={fedexLogo} alt="Fedex logo" />
      <div>
        <span className={css.text}>Free Delivery</span>
        <span className={css.text}>{deliveryDate}</span>
      </div>
    </div>
  );
}
